<template>
  <div class="moreNews">
    <header>
      <div class="g-header" style="background: rgb(14, 21, 48)">
        <div class="left" @click="changego">
          <van-icon name="arrow-left" color="#fff" size="20px" />
        </div>
        <div class="middle fs-18">资讯中心</div>
        <div class="right">
          <div class="btn-save fs-16"></div>
        </div>
      </div>
      <div class="blockHeight"></div>
    </header>

    <div class="mescroll">
      <div>
        <div class="component-news">

          <!-- ✅ 已注释：热门话题框架（不展示） -->
          <!--
          <div class="hot-topic">
            <h2 class="hot-title fw fs-20">{{ $t('remenhuati') }}</h2>
            <div class="hot-content">
              <div
                class="hot-item"
                v-for="(item, index) in tops"
                :key="index"
                @click="changedetail(item)"
              >
                <p class="title">{{ item.title }}</p>
                <p class="join-count fs-10 mr-t5">
                  <span>7706{{ $t('renliulan') }}</span>
                </p>
              </div>
            </div>
          </div>
          -->

          <!-- 分类文章（折叠模式） -->
          <div class="media">
            <van-tabs v-model="active" swipeable sticky @change="onTabChange">
              <van-tab v-for="(tab, index) in articleTabs" :key="index">
                <template #title>
                  {{ $t('news' + tab.id) }}
                </template>

                <template #default>
                  <div v-if="tab.articles && tab.articles.length">
                    <!-- ✅ 手风琴：一行一个标题，点开看内容 -->
                    <van-collapse v-model="activeCollapse" accordion>
                      <van-collapse-item
                        v-for="(a, idx) in tab.articles"
                        :key="a.id"
                        :name="a.id"
                      >
                        <template #title>
                          <div class="collapse-title">
                            <span class="num">{{ idx + 1 }}.</span>
                            <span class="text">{{ a.title }}</span>
                          </div>
                        </template>

                        <!-- 内容直接渲染 HTML（后端返回 <p>...</p> 这种） -->
                        <div class="article-content" v-html="a.content"></div>
                      </van-collapse-item>
                    </van-collapse>
                  </div>

                  <div v-else class="empty">{{ $t('wuTps') }}</div>
                </template>
              </van-tab>
            </van-tabs>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import homeApi from "@/api/home";

export default {
  name: "MoreNews",
  data() {
    return {
      active: 0,
      activeCollapse: "", // ✅ 手风琴当前展开项（accordion）
      tops: [],
      articleTabs: [],
    };
  },
  methods: {
    changego() {
      this.$router.go(-1);
    },

    onTabChange() {
      // 切换分类时收起展开项，避免跨 tab “残留”
      this.activeCollapse = "";
    },

    // articles 可能是数组，也可能是 JSON 字符串：统一处理成数组
    normalizeTabs(tabs) {
      if (!Array.isArray(tabs)) return [];
      return tabs.map((t) => {
        const tab = { ...t };
        if (typeof tab.articles === "string") {
          try {
            tab.articles = JSON.parse(tab.articles);
          } catch (e) {
            tab.articles = [];
          }
        }
        if (!Array.isArray(tab.articles)) tab.articles = [];
        return tab;
      });
    },

    info() {
      this.$toast.loading({
        message: this.$t("jiazaizhong"),
        forbidClick: true,
        duration: 0,
      });

      homeApi
        .articleList()
        .then((data) => {
          this.tops = Array.isArray(data.data.tops) ? data.data.tops : [];
          this.articleTabs = this.normalizeTabs(data.data.articleTabs);
          this.$toast.clear();
        })
        .catch((err) => {
          this.$toast.clear();
          this.$toast.fail(err.msg);
        });
    },
  },
  created() {
    this.info();
  },
};
</script>

<style lang="less" scoped>
.moreNews {
  height: 100%;
}
.mescroll {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.component-news {
  background-color: #0e1530;
  min-height: 100%;
}

/* ✅ 折叠标题：一行一个，超出省略 */
.collapse-title {
  display: flex;
  align-items: center;
  width: 100%;
}
.collapse-title .num {
  margin-right: 0.2rem;
  flex: none;
  color: #fff;
  font-size: 0.36rem;
}
.collapse-title .text {
  flex: 1;
  color: #fff;
  font-size: 0.36rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ✅ 内容区：可换行，保持段落可读 */
.article-content {
  color: #d7d7d7;
  font-size: 0.34rem;
  line-height: 1.6;
  white-space: normal;
  word-break: break-word;
}

/* 让折叠面板背景更接近你截图那种深色块 */
:deep(.van-collapse-item__title) {
  background: #2a3356;
  padding: 0.35rem 0.35rem;
  border-bottom: 8px solid #0e1530;
}
:deep(.van-collapse-item__content) {
  background: #1a243f;
  padding: 0.35rem 0.35rem;
}

.empty {
  padding: 0.4rem;
  color: #a0a0a0;
}
</style>
